import React from 'react';
import { FounderProfile } from './about/FounderProfile';
import { AboutText } from './about/AboutText';
import { AboutHighlights } from './about/AboutHighlights';

export const AboutSection = () => (
  <section id="about" className="section" data-testid="about-section">
    <div className="container">
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <h2 className="heading-1" data-testid="about-heading">
          A trusted wealth advisor, rooted in Hooghly
        </h2>
        <p className="body-large" style={{ maxWidth: '780px', margin: '0 auto', color: 'var(--text-secondary)' }}>
          Institutional-grade financial advisory with the accessibility of a neighbourhood firm —
          built for clients in Chandannagar, Chinsurah and the wider Hooghly region.
        </p>
      </div>

      <div className="about-content">
        <FounderProfile />
        <AboutText />
      </div>

      <AboutHighlights />
    </div>
  </section>
);
